import React from 'react';
import { TextProps } from '@fluentui/react-components';

import { FormCardHeader } from './card-header';
import { AccordionButton } from './accordion-button';
import { FormCardError, FormCardTitle, Spacer } from './common-components';

export interface FormCardDefaultHeaderProps {
  title: string;
  titleAs?: TextProps['as'];
  headingRole?: TextProps['role'];
  headingLevel?: TextProps['aria-level'];
  contentBefore?: React.ReactNode;
  contentAfter?: React.ReactNode;
}

export const FormCardDefaultHeader: React.FC<FormCardDefaultHeaderProps> = ({
  title, contentBefore, contentAfter, headingRole, headingLevel, titleAs,
}) => (
  <FormCardHeader>
    {contentBefore}
    <FormCardTitle
      as={titleAs}
      {...(headingRole) ? { role: headingRole } : {}}
      {...(headingLevel) ? { 'aria-level': headingLevel } : {}}
    >
      {title}
    </FormCardTitle>
    {contentAfter}
    <Spacer />
    <FormCardError />
    <AccordionButton title={title} />
  </FormCardHeader>
);

FormCardDefaultHeader.defaultProps = {
  contentBefore: null,
  contentAfter: null,
  titleAs: undefined,
};
